import * as React from 'react';
import {Environment} from 'relay-runtime';

export type RelayState = Environment;

// @ts-expect-error upgrade
export default React.createContext<RelayState>(null);
